'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _effects = require('redux-saga/effects');

var _institutions = require('../actions/institutions');

var _api = require('../api');

var _marked = /*#__PURE__*/regeneratorRuntime.mark(fetchInstitutions),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(fetchInstitution),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(editInstitution),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(createInstitution),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(fetchInstitutionsRequest),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(fetchInstitutionRequest),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(editInstitutionRequest),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(createInstitutionRequest);

function fetchInstitutions() {
    var response;
    return regeneratorRuntime.wrap(function fetchInstitutions$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return (0, _effects.call)(_api.request, 'get', '/institutions');

                case 3:
                    response = _context.sent;
                    _context.next = 6;
                    return (0, _effects.put)(_institutions.actionCreators.fetchInstitutionsSucceeded(response.data));

                case 6:
                    _context.next = 12;
                    break;

                case 8:
                    _context.prev = 8;
                    _context.t0 = _context['catch'](0);
                    _context.next = 12;
                    return (0, _effects.put)(_institutions.actionCreators.fetchInstitutionsFailed());

                case 12:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this, [[0, 8]]);
}

function fetchInstitution(_ref) {
    var institutionId = _ref.institutionId;
    var response;
    return regeneratorRuntime.wrap(function fetchInstitution$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.prev = 0;
                    _context2.next = 3;
                    return (0, _effects.call)(_api.request, 'get', '/institutions/' + institutionId);

                case 3:
                    response = _context2.sent;
                    _context2.next = 6;
                    return (0, _effects.put)(_institutions.actionCreators.fetchInstitutionSucceeded(response.data));

                case 6:
                    _context2.next = 12;
                    break;

                case 8:
                    _context2.prev = 8;
                    _context2.t0 = _context2['catch'](0);
                    _context2.next = 12;
                    return (0, _effects.put)(_institutions.actionCreators.fetchInstitutionFailed());

                case 12:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this, [[0, 8]]);
}

function editInstitution(_ref2) {
    var institutionId = _ref2.institutionId,
        changes = _ref2.changes,
        redirect = _ref2.redirect;
    return regeneratorRuntime.wrap(function editInstitution$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.prev = 0;
                    _context3.next = 3;
                    return (0, _effects.call)(_api.request, 'put', '/institutions/' + institutionId, changes);

                case 3:
                    _context3.next = 5;
                    return (0, _effects.put)(_institutions.actionCreators.editInstitutionSucceeded());

                case 5:
                    if (!redirect) {
                        _context3.next = 8;
                        break;
                    }

                    _context3.next = 8;
                    return (0, _effects.call)(redirect);

                case 8:
                    _context3.next = 14;
                    break;

                case 10:
                    _context3.prev = 10;
                    _context3.t0 = _context3['catch'](0);
                    _context3.next = 14;
                    return (0, _effects.put)(_institutions.actionCreators.editInstitutionFailed());

                case 14:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this, [[0, 10]]);
}

function createInstitution(_ref3) {
    var institution = _ref3.institution,
        redirect = _ref3.redirect;
    return regeneratorRuntime.wrap(function createInstitution$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.prev = 0;
                    _context4.next = 3;
                    return (0, _effects.call)(_api.request, 'post', '/institutions/', institution);

                case 3:
                    _context4.next = 5;
                    return (0, _effects.put)(_institutions.actionCreators.createInstitutionSucceeded());

                case 5:
                    if (!redirect) {
                        _context4.next = 8;
                        break;
                    }

                    _context4.next = 8;
                    return (0, _effects.call)(redirect);

                case 8:
                    _context4.next = 14;
                    break;

                case 10:
                    _context4.prev = 10;
                    _context4.t0 = _context4['catch'](0);
                    _context4.next = 14;
                    return (0, _effects.put)(_institutions.actionCreators.createInstitutionFailed());

                case 14:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this, [[0, 10]]);
}

function fetchInstitutionsRequest() {
    return regeneratorRuntime.wrap(function fetchInstitutionsRequest$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.next = 2;
                    return (0, _effects.takeLatest)(_institutions.actionTypes.FETCH_INSTITUTIONS_REQUEST, fetchInstitutions);

                case 2:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

function fetchInstitutionRequest() {
    return regeneratorRuntime.wrap(function fetchInstitutionRequest$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    _context6.next = 2;
                    return (0, _effects.takeLatest)(_institutions.actionTypes.FETCH_INSTITUTION_REQUEST, fetchInstitution);

                case 2:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

function editInstitutionRequest() {
    return regeneratorRuntime.wrap(function editInstitutionRequest$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    _context7.next = 2;
                    return (0, _effects.takeLatest)(_institutions.actionTypes.EDIT_INSTITUTION_REQUEST, editInstitution);

                case 2:
                case 'end':
                    return _context7.stop();
            }
        }
    }, _marked7, this);
}

function createInstitutionRequest() {
    return regeneratorRuntime.wrap(function createInstitutionRequest$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    _context8.next = 2;
                    return (0, _effects.takeLatest)(_institutions.actionTypes.CREATE_INSTITUTION_REQUEST, createInstitution);

                case 2:
                case 'end':
                    return _context8.stop();
            }
        }
    }, _marked8, this);
}

exports.default = [fetchInstitutionsRequest, fetchInstitutionRequest, editInstitutionRequest, createInstitutionRequest];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/effects/institutions.js
// module id = 2222
// module chunks = 0